import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
import { getFancyState } from './utils';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    isFancy,
    position,
    width
  } = _ref;
  var fancyState = getFancyState(isFancy);
  var knobBackgroundColor = designContext.get('slider/knob-background-color', {
    fancyState
  });
  var knobBorderColor = designContext.get('slider/knob-border-color', {
    fancyState
  });
  var leftBarBackgroundColor = designContext.get('slider/left-bar-background-color', {
    fancyState
  });
  var rightBarBackgroundColor = designContext.get('slider/right-bar-background-color', {
    fancyState
  });
  var barBorderRadius = designContext.get('slider/bar-corner-radius').pixelValue;
  var knobBorderRadius = designContext.get('slider/knob-corner-radius').pixelValue;
  var barHeight = designContext.get('slider/bar-height', {
    fancyState
  }).value();
  var chevronHorizontalPadding = designContext.get('slider/chevron-horizontal-padding', {
    fancyState
  }).value();
  var knobSize = designContext.get('slider/knob-size', {
    fancyState
  }).value();
  return {
    rootStyle: _objectSpread(_objectSpread({}, platformSelect({
      web: {
        alignItems: 'stretch',
        borderStyle: 'solid',
        borderWidth: 0,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        minHeight: 0,
        minWidth: 0,
        outline: 'none',
        userSelect: 'none',
        zIndex: 0
      },
      native: {}
    })), {}, {
      position: 'relative',
      width,
      height: knobSize
    }),
    touchableStyle: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 3
    },
    leftBarStyle: {
      borderRadius: barBorderRadius,
      position: 'absolute',
      backgroundColor: leftBarBackgroundColor.toString(),
      width: position === 0 // leftmost
      ? 0 : position === width - knobSize // rightmost
      ? width : position + knobSize / 2,
      height: barHeight,
      left: 0,
      top: '50%',
      marginTop: -barHeight / 2
    },
    rightBarStyle: {
      position: 'absolute',
      backgroundColor: rightBarBackgroundColor.toString(),
      borderRadius: barBorderRadius,
      width: position === 0 // leftmost
      ? width : position === width - knobSize // rightmost
      ? 0 : width - position - knobSize / 2,
      height: barHeight,
      top: '50%',
      right: 0,
      marginTop: -barHeight / 2
    },
    knobStyle: _objectSpread(_objectSpread({}, platformSelect({
      web: _objectSpread({
        cursor: 'pointer',
        willChange: 'left'
      }, isFancy ? {
        boxShadow: 'rgba(0, 0, 0, 0.15) 0 2px 20px 0'
      } : {}),
      ios: _objectSpread({}, isFancy ? {
        shadowRadius: 10,
        shadowColor: 'rgba(0, 0, 0, 0.15)',
        shadowOpacity: 1,
        shadowOffset: {
          width: 0,
          height: 2
        }
      } : {}),
      android: _objectSpread({}, isFancy ? {
        elevation: 4
      } : {})
    })), {}, {
      position: 'absolute',
      borderWidth: barHeight,
      borderColor: knobBorderColor.toString(),
      backgroundColor: knobBackgroundColor.toString(),
      borderRadius: knobBorderRadius,
      left: position,
      top: 0,
      width: knobSize,
      height: knobSize
    }),
    leftChevronStyle: {
      position: 'absolute',
      left: chevronHorizontalPadding,
      top: (knobSize - 20) / 2 - barHeight
    },
    rightChevronStyle: {
      position: 'absolute',
      right: chevronHorizontalPadding,
      top: (knobSize - 20) / 2 - barHeight
    },
    iconStyle: {
      colorToken: 'slider/icon-color'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map